import React from 'react';

import {
  // CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  StripeProvider,
  Elements,
  injectStripe
} from 'react-stripe-elements';
import { PropagateLoader } from 'react-spinners';

const STRIPE_PK =
  window.location.hostname.indexOf('vetchat.com.au') > -1
    ? process.env.REACT_APP_STRIPE_PK_PROD
    : process.env.REACT_APP_STRIPE_PK_TEST;

const loaderStyle = {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'center'
};

const createOptions = (fontSize, padding) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em',
        fontFamily: 'Source Code Pro, monospace',
        '::placeholder': {
          color: '#aab7c4'
        },
        padding
      },
      invalid: {
        color: '#9e2146'
      }
    }
  };
};

const _CardForm = props => {
  return (
    <>
      <div className='row form-stripe'>
        <div className='col-sm-12 stripe-element'>
          <label>
            Card number
            <CardNumberElement {...createOptions(props.fontSize)} />
          </label>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-6 stripe-element'>
          <label>
            Expiration date
            <CardExpiryElement {...createOptions(props.fontSize)} />
          </label>
        </div>
        <div className='col-xs-6 stripe-element'>
          <label>
            CVC
            <CardCVCElement {...createOptions(props.fontSize)} />
          </label>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 space-small-bottom text-center'>
          <p>
            By clicking {props.buttonText.toLowerCase()}, you accept our&nbsp;
            <a
              target='_blank'
              href='/terms-and-conditions'
              className='signup-link'
            >
              terms and conditions
            </a>
            &nbsp;and&nbsp;
            <a target='_blank' href='/privacy-policy' className='signup-link'>
              privacy policy
            </a>
            . We'll ocassionally send account related emails.
          </p>
          <button
            className='btn btn-pay'
            onClick={() => {
              props.processPayment(props.stripe);
            }}
          >
            {props.processing ? (
              <div style={loaderStyle}>
                <PropagateLoader color={'#36D7B7'} />
              </div>
            ) : (
              props.buttonText
            )}
          </button>
        </div>
        <div className='col-xs-12 text-center space-small-bottom'>
          <img src='/images/powered_by_stripe.png' alt='powered by stripe' />
        </div>
      </div>
    </>
  );
};

const CardForm = injectStripe(_CardForm);

const StripeCardForm = props => {
  return (
    <StripeProvider apiKey={STRIPE_PK}>
      <Elements>
        <CardForm fontSize='18px' {...props} />
      </Elements>
    </StripeProvider>
  );
};

export default StripeCardForm;
